import { DynamicField } from "./dynamic-field.model";

export class DynamicDragDrop<T> extends DynamicField<T> {

    showList?: boolean;
    showErrorList?: boolean;
    showUpload?: boolean;
    hideOnComplete?: boolean;
    multiple?: boolean;
    maxSize?: number;
    maxFiles?: number;
    text?: string;
    icon?: string;
    maxFilesError?: string;
    maxSizeError?: string;
    fileTypeError?: string;
    accept?: string;
    collapsable?: boolean;


    constructor(source: Partial<DynamicDragDrop<T>>) {
        super();
        Object.assign(this, source);
    }
}